export class ProductSetupRequest {
  manufacturer: string;
  manufacturerPartNumber: string;
  productDescription: string;
  comments: string;
  marketId:string;
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/api/models/product-setup-request.ts